import { render, staticRenderFns } from "./FooterLayout.vue?vue&type=template&id=2827564f&scoped=true"
import script from "./FooterLayout.vue?vue&type=script&lang=js"
export * from "./FooterLayout.vue?vue&type=script&lang=js"
import style0 from "./FooterLayout.vue?vue&type=style&index=0&id=2827564f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2827564f",
  null
  
)

export default component.exports